export const POPULAR_DESTINATIONS = [
  {
    label: "Cairo, (CAI)",
    value: "CAI",
    country: "Egypt",
    city: "Cairo",
    iataCode: "CAI",
    airport: "Cairo International Airport",
  },
  {
    label: "Jeddah, (JED)",
    value: "JED",
    country: "Saudi Arabia",
    city: "Jeddah",
    iataCode: "JED",
    airport: "King Abdulaziz International",
  },
  {
    label: "Dubai, (DXB)",
    value: "DXB",
    country: "United Arab Emirates",
    city: "Dubai",
    iataCode: "DXB",
    airport: "Dubai",
  },
  {
    label: "New York, (JFK)",
    value: "JFK",
    country: "United States",
    city: "New York",
    iataCode: "JFK",
    airport: "John F Kennedy International",
  },
  {
    label: "Nagoya, (NGO)",
    value: "NGO",
    country: "Japan",
    city: "Nagoya",
    iataCode: "NGO",
    airport: "Chu-Bu Centrair International (Central Japan International)",
  },
];
